import React from 'react';
import { VStack, Text } from '@chakra-ui/react';
import HeroSection from '../components/common/HeroSection';
import Content from '../components/impressum/content';
import MiniNavbar from '../components/common/MiniNavbar'; 

const Home = () => {
  return (
    <VStack spacing={0}>
      <HeroSection />
     {/* {isMobileView && <JoinCommunity />} */}
     <MiniNavbar/>
      <Content/>
      {/* {!isMobileView &&<JoinCommunity />} */}
    </VStack>
  );
};

export default Home;
